import { Container } from 'inversify';
import { Actions } from './Actions';
import { RequestGeocoder } from './core/RequestGeocoder';
import { RequestRouting } from './core/RequestRouting';
import { RequestSearchByAddress } from './core/RequestSearchByAddress';
import { RequestSearchByCountry } from './core/RequestSearchByCountry';
import { RequestSearchById } from './core/RequestSearchById';
import { RequestSearchByLocation } from './core/RequestSearchByLocation';
import { RequestSearchByPosition } from './core/RequestSearchByPosition';
import { RequestSearchByRectangle } from './core/RequestSearchByRectangle';
import { CommandStorage, saveCmdInstance } from './core/storage/CommandStorage';
import { DetailsStorage } from './core/storage/DetailsStorage';
import { RoutingStorage } from './core/storage/RoutingStorage';
import { SearchStorage } from './core/storage/SearchStorage';
import { ContainerTypes } from './core/types/ContainerTypes';
import { SearchTypes } from './core/types/SearchTypes';
import { SearchById } from './interfaces/webservices/SearchResults';
import { ConfigLoader } from './ConfigLoader';
import {
	SearchByAddress,
	SearchByCountry,
	SearchByLocation,
	SearchByPosition,
	SearchByRectangle
} from './interfaces/webservices/SearchResults';
import { Ekomi } from './Ekomi';
import { AppBehavior } from './core/AppBehavior';
import { GPS } from './core/GPS';

export const container = new Container();

container
	.bind<AppBehavior>('behavior')
	.to(AppBehavior)
	.inSingletonScope();

container
	.bind<GPS>('gps')
	.to(GPS)
	.inSingletonScope();

container
	.bind<Ekomi>(ContainerTypes.Ekomi)
	.to(Ekomi)
	.inSingletonScope();

container
	.bind<ConfigLoader>(ContainerTypes.Config)
	.to(ConfigLoader)
	.inSingletonScope();

container
	.bind<SearchById>(SearchTypes.Id)
	.to(RequestSearchById)
	.inSingletonScope();
container
	.bind<SearchByAddress>(SearchTypes.Address)
	.to(RequestSearchByAddress)
	.inSingletonScope();
container
	.bind<SearchByLocation>(SearchTypes.Location)
	.to(RequestSearchByLocation)
	.inSingletonScope();
container
	.bind<SearchByPosition>(SearchTypes.Position)
	.to(RequestSearchByPosition)
	.inSingletonScope();
container
	.bind<SearchByRectangle>(SearchTypes.Rectangle)
	.to(RequestSearchByRectangle)
	.inSingletonScope();
container
	.bind<SearchByCountry>(SearchTypes.Country)
	.to(RequestSearchByCountry)
	.inSingletonScope();
container
	.bind<RequestRouting>(SearchTypes.Routing)
	.to(RequestRouting)
	.inSingletonScope();
container
	.bind<RequestGeocoder>(SearchTypes.Geocoding)
	.to(RequestGeocoder)
	.inSingletonScope();

// will be generated once for every scope
container
	.bind<Actions>(ContainerTypes.Action)
	.to(Actions)
	.inSingletonScope();

container
	.bind<SearchStorage>(ContainerTypes.SearchStorage)
	.to(SearchStorage)
	.inSingletonScope();

container
	.bind<CommandStorage>(ContainerTypes.CommandStorage)
	.to(CommandStorage)
	.inSingletonScope();

container
	.bind<DetailsStorage>(ContainerTypes.DetailsStorage)
	.to(DetailsStorage)
	.inSingletonScope();

container
	.bind<RoutingStorage>(ContainerTypes.RoutingStorage)
	.to(RoutingStorage)
	.inSingletonScope();

saveCmdInstance(container.get<CommandStorage>(ContainerTypes.CommandStorage));
